import HistoryApprovalPeluang from './HistoryApprovalPeluang';

export default HistoryApprovalPeluang;
